__turbopack_context__.v({
  "avatar": "skeletons-module__JzBupW__avatar",
  "chipSlot": "skeletons-module__JzBupW__chipSlot",
  "content": "skeletons-module__JzBupW__content",
  "detailRow": "skeletons-module__JzBupW__detailRow",
  "detailRows": "skeletons-module__JzBupW__detailRows",
  "floorHead": "skeletons-module__JzBupW__floorHead",
  "itemRegion": "skeletons-module__JzBupW__itemRegion",
  "lensArrange": "skeletons-module__JzBupW__lensArrange",
  "rounded": "skeletons-module__JzBupW__rounded",
  "structure": "skeletons-module__JzBupW__structure",
  "titleLine": "skeletons-module__JzBupW__titleLine",
  "wideOnly": "skeletons-module__JzBupW__wideOnly",
});
